import { UserInDto } from '../../../types/user.dto'

export const GET_ONE_USER = 'GET_ONE_USER'
export const GET_ONE_USER_SUCCESS = 'GET_ONE_USER_SUCCESS'
export const GET_ONE_USER_ERROR = 'GET_ONE_USER_ERROR'
export const RESET_GET_ONE_USER = 'RESET_ONE_USER'

export const SET_ONE = 'SET_ONE'
export const SET_ONE_SUCCESS = 'SET_ONE_SUCCESS'
export const SET_ONE_ERROR = 'SET_ONE_ERROR'

export interface GetOneUser {
  type: typeof GET_ONE_USER
  payload: { idUser: string }
}

export interface GetOneUserSuccess {
  type: typeof GET_ONE_USER_SUCCESS
  payload: UserInDto
}

export interface GetOneUserError {
  type: typeof GET_ONE_USER_ERROR
  payload: boolean | string
}

export interface ResetOneUser {
  type: typeof RESET_GET_ONE_USER
  payload: null
}

export interface State {
  data: UserInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetOneUser | GetOneUserSuccess | GetOneUserError | ResetOneUser
